import { Customer, User } from '@/types';

export const state = {
    customer: null as null | Customer[],
    user: null as null | User,
    allCustomers: null as null | Customer[],
    users: null as null | User[],
};
export type State = typeof state;
